import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Calculations icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Calculations } from '@sravni/design-system-icons'
 *
 * <Calculations />
 * ```
 */
var Calculations = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Calculations", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19 21a2 2 0 0 0 2-2v-6a1 1 0 0 0-1-1h-3v7a2 2 0 0 0 2 2ZM7 8h6M7 11.87h6M7 16.06h3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17 12V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v14a2 2 0 0 0 2 2h14", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Calculations };
//# sourceMappingURL=Calculations.js.map
